import React from "react"

import { QuestionParagraph, AnswerParagraph } from "../typography"

const QaList = ({ items }) => (
  <div>
    {items.map(item => (
      <div style={{ marginBottom: "42px" }} key={`${item.q}`}>
        <QuestionParagraph style={{ marginBottom: "15px" }}>
          {item.q}
        </QuestionParagraph>
        <AnswerParagraph>{item.a}</AnswerParagraph>
      </div>
    ))}
  </div>
)

export default QaList
